// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation
var GUID_REGEX = new RegExp("^(?:{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}}{0,1})$");
export var setCookie = function (name, value, age) {
    if (age === void 0) { age = 31536000; }
    document.cookie = "".concat(name, "=").concat(value, "; samesite=strict; max-age=").concat(age, "; secure");
};
export var getCookie = function (name) {
    var _a;
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2)
        return ((_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(";").shift()) || "";
    return "";
};
export var generateGuid = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
export var validateGuid = function (value) {
    if (!value)
        return false;
    return GUID_REGEX.test(value);
};
